module.exports = __webpack_public_path__ + "static/media/killJoy.78d93fcb.png";